import React from "react";
import { useForm } from "../FormContext";
import { Check } from "lucide-react";
import type { CheckboxFieldProps } from "../../../interfaces/components/form";

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  name,
  value,
  onChange,
  onBlur,
  className = "",
  disabled = false,
}) => {
  const { setFieldValue, setFieldTouched, validateField, fields } = useForm();
  const fieldValue = fields[name]?.value ?? value ?? false;
  const fieldErrors = fields[name]?.errors || [];
  const hasError = fieldErrors.length > 0;

  const handleChange = () => {
    if (disabled) return;
    const newValue = !fieldValue;
    setFieldValue(name, newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleBlur = () => {
    setFieldTouched(name, true);
    validateField(name);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <div className={`flex items-center gap-2  min-h-[36px] ${className}`}>
      <button
        type="button"
        role="checkbox"
        aria-checked={fieldValue}
        onClick={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        className={`
          relative w-5 h-5 rounded border-2 flex items-center justify-center
          transition-colors duration-200 border-solid border-primary
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
          ${fieldValue ? "bg-primary border-primary" : "bg-white dark:bg-darkCardBackground border-gray-300 dark:border-gray-600"}
          ${hasError ? "border-red-500" : ""}
          focus:outline-none focus:ring-0 focus:ring-primary/50 focus:ring-offset-1
        `}
      >
        {fieldValue && (
          <Check size={14} className="text-white" strokeWidth={3} />
        )}
      </button>
    </div>
  );
};
